import { IChangePasswordBody, IUser } from 'src/types/user.type';
import http from 'src/utils/http';
import BaseService from './base.service';

export default class UserService extends BaseService<IUser> {
  constructor() {
    super('/api/user');
  }

  public async changePassword(body: IChangePasswordBody) {
    const { data } = await http.put<boolean>(`${this.url}/change-pass`, body);
    return data;
  }

  public async profile() {
    const { data } = await http.get<IUser>(`${this.url}/profile`);
    return data;
  }
}
